import React, { forwardRef } from 'react';

const Input = forwardRef(({
  label,
  error,
  hint,
  id,
  className = '',
  icon,
  required = false,
  ...props
}, ref) => {
  const inputId = id || Math.random().toString(36).substring(7);
  const inputClass = `form-input ${error ? 'error' : ''} ${className}`;

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={inputId} className="form-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      
      {icon ? (
        <div className="input-wrapper">
          <span className="input-icon">{icon}</span>
          <input
            id={inputId}
            ref={ref}
            className={inputClass}
            {...props}
          />
        </div>
      ) : (
        <input
          id={inputId}
          ref={ref}
          className={inputClass}
          {...props}
        />
      )}
      
      {error && <span className="form-error">{error}</span>}
      {hint && !error && <span className="form-hint">{hint}</span>}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
